window.dtHire = function () {
  const dt_hire = new DataTable('#hire-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#hire-datatable').data('source'),
      data: function (d) {
        d.begin_date = $("#dt-begin-date").val(),
        d.end_date = $("#dt-end-date").val()
      },
      beforeSend: function () { showLoadingRow('#hire-datatable', 8); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[3, 'desc'], [0, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "date" },
      { "data": "code" },
      { "data": "department" },
      { "data": "position" },
      { "data": "work_contract" },
      { "data": "candidate_code" },
      { "data": "candidate_first_name" },
      { "data": "candidate_last_name" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
      $('td:eq(7)', row).html(`${data.candidate_code} ${data.candidate_first_name} ${data.candidate_last_name}`);
      $('td:eq(7)', row).attr('colspan', 3);
      $('td:eq(8)', row).remove()
      $('td:eq(8)', row).remove()
    },
  });

  dtFinalTouch(
    {doubleDateFilter: true}
  )

  $(document).off("change", "#dt-begin-date, #dt-end-date")
  $(document).on("change", "#dt-begin-date, #dt-end-date", function(){
    dt_hire.ajax.reload()
  })
}

 